import { world } from '../languages';
import session from './session';

export const WEBSOCKET_OPEN_STATE_CODE = 1;

type WebsocketClientInstanceProps = {
    instance: WebSocket | null;
    connect: () => void;
};

type WebsocketMessageProps = {
    access_token?: string;
    type: string;
    world?: string;
};

type WebsocketCallback = (data: IWebsocketMessage) => void;

function WebsocketClient(callback: WebsocketCallback): WebsocketClientInstanceProps {
    const HEARTBEAT_INTERVAL = 30000;
    let instance: WebSocket | null = null;
    let reconnectTimeout = 2;
    let heartbeatIntervalHandler: NodeJS.Timeout | number = 0;

    const connect = (): void => {
        const host = process.env.REACT_APP_API_URL?.replace('/api/', '').replace('https://', '');

        instance = new WebSocket(`wss://${host}:443/notifications`);
        
        instance.onopen = async (): Promise<void> => {
            reconnectTimeout = 2;
            console.info(new Date(), 'Connected to WebSocket server.');
            
            const handshakeMessage: WebsocketMessageProps = {
                access_token: session.getAccessToken(),
                type: 'handshake',
                world
            };
            
            instance?.send(JSON.stringify(handshakeMessage));

            if (heartbeatIntervalHandler) {
                clearInterval(heartbeatIntervalHandler);
            }
            
            heartbeatIntervalHandler = setInterval(() => {
                console.info(new Date(), 'Heartbeat');
                if (instance?.readyState === WEBSOCKET_OPEN_STATE_CODE) {
                    const heartbeatMessage: WebsocketMessageProps = {
                        type: 'heartbeat'
                    };

                    instance.send(JSON.stringify(heartbeatMessage));
                }
            }, HEARTBEAT_INTERVAL);
        };

        instance.onmessage = (e: MessageEvent): void => {
            callback(JSON.parse(e.data));
        };

        instance.onerror = (): void => {
            instance?.close();
        };

        instance.onclose = (e: CloseEvent): void => {
            if (String(e.reason).indexOf('no_reconnect') >= 0) {
                return;
            }

            console.info(
                new Date(),
                `Socket is closed. Reconnect will be attempted in ${reconnectTimeout} seconds.`,
                e.reason
            );

            setTimeout(() => {
                connect();
            }, 1000 * reconnectTimeout++);
        };
    };

    connect();

    return {
        instance,
        connect
    };
}

export default WebsocketClient;
